import {
  FETCH_PROFCOUNTRY_ACTION,
  FETCH_PROFCOUNTRY_SUCCESS_ACTION,
  FETCH_PROFCOUNTRY_FAIL_ACTION,
  FETCH_REGION_ACTION,
  FETCH_REGION_SUCCESS_ACTION,
  FETCH_REGION_FAIL_ACTION,
  FETCH_LOCATION_ACTION,
  FETCH_LOCATION_SUCCESS_ACTION,
  FETCH_LOCATION_FAIL_ACTION,
  FETCH_OPEQUIPMENT_SUCCESS_ACTION,
  FETCH_CARGOTYPE_SUCCESS_ACTION,
} from "./action";

const initialState = {
  prcssng: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PROFCOUNTRY_ACTION:
      return {
        ...state,
        processing: true,
      };

    case FETCH_PROFCOUNTRY_SUCCESS_ACTION:
      console.log("===countryList====", action.payload.rows);
      return {
        ...state,
        processing: false,
        error: false,
        errorCode: null,
        errorMessage: null,
        countrydetailList: action.payload.rows,
      };

    case FETCH_PROFCOUNTRY_FAIL_ACTION:
      return {
        ...state,
        processing: false,
      };

    case FETCH_REGION_SUCCESS_ACTION:
      return {
        ...state,

        regionList: action.payload.rows,
      };

    case FETCH_LOCATION_SUCCESS_ACTION:
      return {
        ...state,

        locationList: action.payload.rows,
      };

    case FETCH_OPEQUIPMENT_SUCCESS_ACTION:
      return {
        ...state,

        equipmentList: action.payload.rows,
      };

    case FETCH_CARGOTYPE_SUCCESS_ACTION:
      return {
        ...state,

        cargotypeList: action.payload.rows,
      };

    default:
      return {
        ...state,
      };
  }
}
